export const productNavigatePath = (product) => {
  return `/product-details/${product?.code}/${product?.variant?.[0]?.code}${
    product?.SEO?.slug
      ? "/" + product?.SEO?.slug?.trim()?.split(" ")?.join("-")
      : "/" + product?.name?.trim()?.split(" ")?.join("-")
  }`;
};
export const blogNavigatePath = (blog) => {
  return `/blog-details/${blog?.code}${
    blog?.SEO?.slug
      ? "/" + blog?.SEO?.slug?.trim()?.split(" ")?.join("-")
      : "/" + blog?.title?.trim()?.split(" ")?.join("-")
  }`;
};